/* istanbul ignore file */
import { Fill, Style } from 'exceljs'

export const verticalMiddleStyle = Object.freeze({ alignment: { vertical: 'middle' } }) as Style

export const leftStyle = Object.freeze({
  alignment: { horizontal: 'left', vertical: 'middle' },
}) as Style

export const centerCenterStyle = Object.freeze({
  alignment: { horizontal: 'center', vertical: 'middle' },
}) as Style

export const boldStyle = Object.freeze({
  font: { bold: true },
}) as Style

export const underlineStyle = Object.freeze({
  font: { color: { argb: '000000FF' }, underline: true },
}) as Style

export const fillGrey50 = Object.freeze({
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'F3F3F3' },
}) as Fill

export const nameStyle = Object.freeze({
  ...verticalMiddleStyle,
  fill: { ...fillGrey50 },
}) as Style // freeze to avoid accidental modification

export const nameStyleCenter = Object.freeze({
  ...nameStyle,
  alignment: { horizontal: 'center', vertical: 'middle' },
}) as Style

export const bgGrey100 = Object.freeze({
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'E9E9E9' },
  },
}) as Style

export const valueStyleMili = Object.freeze({
  alignment: { horizontal: 'right', vertical: 'middle' },
  numFmt: '0',
}) as Style

export const valueStyleMeter = Object.freeze({
  alignment: { horizontal: 'right', vertical: 'middle' },
  numFmt: '0.0000',
}) as Style

export const plusMinusValueStyleMili = Object.freeze({
  ...valueStyleMili,
  numFmt: '±0',
}) as Style

export const plusMinusValueStyleMeter = Object.freeze({
  ...valueStyleMeter,
  numFmt: '±0.0000',
}) as Style

export const plusValueStyleWhole = Object.freeze({
  ...valueStyleMeter,
  numFmt: '+0',
}) as Style

export const valueFailed = Object.freeze({
  font: { color: { argb: 'FF0000' } },
}) as Style

export const summaryTitleStyle = Object.freeze({
  ...boldStyle,
  ...verticalMiddleStyle,
}) as Style

export const planeHeaderFill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'CCCCCC' },
} as Fill

export const planeHeaderStyle = {
  fill: planeHeaderFill,
} as Style
